<template>
    <navbar>
        <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
            &#9776;
        </button>
        <a class="navbar-brand"></a>
        <ul class="nav navbar-nav d-md-down-none">
            <li class="nav-item">
                <a class="nav-link navbar-toggler sidebar-toggler" @click="sidebarMinimize">&#9776;</a>
            </li>

        </ul>
        <!--<ul class="nav navbar-nav d-md-down-none">-->
        <!---->
        <!--<li class="nav-item header-item">-->
        <!---->

        <!--<router-link tag="div" to='/'  style="height:55px;" class="nav-link">-->
        <!--<p><Icon type="compose" size='30' color="#2d8cf0"></Icon></p>-->
        <!--<p  style="color:white"> 留言管理 </p>-->
        <!--</router-link> -->
        <!--</li>-->
        <!--<li class="nav-item header-item">-->
        <!---->
        <!--<router-link tag="div" to='/home1'  style="height:55px;" class="nav-link">-->
        <!--<p><Icon type="stats-bars" size='30' color="#2d8cf0"></Icon></p>-->
        <!--<p  style="color:white"> 浏览排行 </p>-->
        <!--</router-link> -->


        <!--</li>-->

        <!--<li class="nav-item header-item">-->
        <!--&lt;!&ndash;   &ndash;&gt;-->

        <!--<Dropdown>-->
        <!--<router-link tag="div" to='/'  style="height:55px;" class="nav-link">-->
        <!--<p><Icon type="android-cloud" size='30' color="#2d8cf0"></Icon></p>-->
        <!--<p  style="color:white"> 云服务器 </p>-->
        <!--</router-link>-->
        <!--<DropdownMenu slot="list">-->
        <!--<DropdownItem>Linux</DropdownItem>-->
        <!--<DropdownItem>Mac OS X</DropdownItem>-->
        <!--<DropdownItem>Windows</DropdownItem>-->
        <!---->
        <!--<DropdownItem>Core OS</DropdownItem>-->
        <!--</DropdownMenu>-->
        <!--</Dropdown>-->


        <!--</li>-->


        <!--<li class="nav-item header-item">-->
        <!---->

        <!--<router-link tag="div" to='/home1'  style="height:55px;" class="nav-link">-->
        <!--<p><Icon type="trophy" size='30' color="#2d8cf0"></Icon></p>-->
        <!--<p  style="color:white"> 销量排行 </p>-->
        <!--</router-link> -->


        <!--</li>-->


        <!---->
        <!--</ul>-->
        <Dropdown>
            <Button size="large" icon="md-globe" type="primary" id="langbtn">
                {{$t('switchLanguages')}}
            </Button>
            <DropdownMenu slot="list" v-model="locale">
                <DropdownItem v-for="(item,index) in changeLang" :value="item.value" :key="index"
                              @click.native="changeLangFn(item.value)">
                    {{ item.label }}
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>

        <!--<div v-if="role=='thirdAgent'">-->
            <!--<Dropdown>-->
                <!--<Button type="primary" >-->
                    <!--{{$t('switchLanguages')}}{{locale}}-->
                    <!--<Icon type="arrow-down-b"></Icon>-->
                <!--</Button>-->
                <!--<DropdownMenu slot="list" v-model="locale">-->
                    <!--<DropdownItem v-for="(item,index) in changeLang" :value="item.value" :key="index"-->
                                  <!--@click.native="changeLangFn(item.value)">-->
                        <!--{{ item.label }}-->
                    <!--</DropdownItem>-->
                <!--</DropdownMenu>-->
            <!--</Dropdown>-->
        <!--</div>-->
        <!--<Select v-model="locale" @on-change="changeLangFn" style="width:100px;" placeholder="切换语言">-->
        <!--<Option v-for="(item,index) in changeLang" :value="item.value" :key="index">{{item.label}}</Option>-->
        <!--</Select>-->



        <ul class="nav navbar-nav ml-auto">
            <div style="float: right;display: block;margin-right: 50px;" >
                <i-button type="success" @click="contact">{{$t('contact')}}</i-button>
            </div>
            <!--<li class="nav-item d-md-down-none">-->
            <!--<a class="nav-link" ><Icon type="android-notifications" size="20"></Icon><span class="badge badge-pill badge-danger">5</span></a>-->
            <!--</li>-->
            <Dropdown class="nav-item">
                <a href="javascript:void(0)">
                   <span slot="button">
                  <img src="static/img/avatars/6.jpg" class="img-avatar" alt="o">
                  <span class="d-md-down-none">{{account}}</span>
                  </span>
                </a>
                <Dropdown-menu slot="list">
                    <!--<Dropdown-item>-->
                    <!--<p class="dropdown-itemp"><Icon type="alert"></Icon>Updates<span class="badge badge-info">42</span></p>-->

                    <!---->
                    <!--</Dropdown-item>-->
                    <!--<Dropdown-item>-->
                    <!--<p class="dropdown-itemp"><Icon type="chatbox-working"></Icon>Messages<span class="badge badge-success">42</span></p>-->

                    <!--</Dropdown-item>-->
                    <!--<Dropdown-item>-->
                    <!--<p class="dropdown-itemp">  <Icon type="chatbox-working"></Icon>Messages<span class="badge badge-danger">42</span></p>-->

                    <!--</Dropdown-item>-->
                    <Dropdown-item>
                        <p class="dropdown-itemp" @click="perDetails">
                            <Icon type="android-contact"></Icon>
                            {{$t('personalInformation')}}
                        </p>
                    </Dropdown-item>
                    <Dropdown-item >
                        <p class="dropdown-itemp" @click="ChangePassword">
                            <Icon type="android-settings"></Icon>
                            {{$t('agent.editPassword')}}
                        </p>
                    </Dropdown-item>

                    <Dropdown-item><a href="" @click="Logout">
                        <p class="dropdown-itemp">
                            <Icon type="power"></Icon>
                            {{$t('logout')}}
                        </p>
                    </a></Dropdown-item>

                </Dropdown-menu>
            </Dropdown>


            <li class="nav-item d-md-down-none">
                <!--<a class="nav-link navbar-toggler aside-menu-toggler"  @click="asideToggle">&#9776;</a>-->
            </li>
        </ul>
        <perDetails :details="details" v-on:closeWin="closeWin"></perDetails>
        <ChangePassword :Form="Form" v-on:closePasswordForm="closePasswordForm"></ChangePassword>
    </navbar>

</template>
<script>
    import perDetails from '../views/components/perDetails';
    import ChangePassword from '../views/components/ChangePassword';
    import navbar from './Navbar'

    export default {
        name: 'headerApp',
        components: {
            navbar,
            perDetails,
            ChangePassword
        },
        data() {
            return {
                role: '',
                screenWidth: '',
                locale: '',//locale存储sel语言的选择信息
                changeLang: [
                    {value: "zh", label: this.$t('simplifiedChinese')},
                    {value: "en", label: this.$t('english')}
                    // {value: "tc",label: "繁體中文"}
                ],
                details: '',
                Form: '',
                account: this.$store.getters.subAccount ? this.$store.getters.subAccount : this.$store.getters.account
            }
        },
        methods: {
            Logout(e) {
                e.preventDefault();
                this.$store.dispatch('LogOut').then(() => {
                    this.$router.push({path: '/login'});
                    window.location.reload();
                }).catch(err => {
                    this.$message.error(err);
                });
            },
            perDetails() {
                this.details = this.$store.getters.uid;
            },
            ChangePassword() {
                this.Form = this.$store.getters;
                console.log(this.$store.getters);
            },
            closePasswordForm() {
                this.Form = '';
            },
            closeWin() {
                this.details = '';
            },
            click() {
                // do nothing
            },
            sidebarToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-hidden')
            },
            sidebarMinimize(e) {
                e.preventDefault()

                document.body.classList.toggle('sidebar-minimized')
            },
            mobileSidebarToggle(e) {
                e.preventDefault()

                document.body.classList.toggle('sidebar-mobile-show')
            },
            asideToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('aside-menu-hidden')
            },
            //   切换多语言
            changeLangFn(val) {
                let chan = this.changeLang;
                for (let i in chan) {
                    if (chan[i].value === val) {
                        this.locale = this.$i18n.locale = chan[i].value;
                        localStorage.setItem("language", chan[i].value);
                    }
                }
                this.$router.go(0);
            },
            contact(){
                window.open('https://sct-chat.npnchina.com/web/index.html#/pages/message/customer?confid_id=1131c339-0848-4ea3-89ed-f0d354e68c15','_blank')
            }
        },
        mounted() {
            if (window.innerWidth < 1000) {
                $('#langbtn').css('position', 'relative');
                $('#langbtn').css('left', '50px');
                $('#langbtn').css('top', '-44px');
                $('.navbar-brand').css('padding','.5rem 1rem .5rem  26rem');
            } else {
                $('#langbtn').css('position', 'none');
                $('#langbtn').css('left', '0px');
                $('#langbtn').css('top', '0px');
            }
            window.onresize = () => {
                return (() => {
                    window.screenWidth = window.innerWidth;
                    this.screenWidth = window.screenWidth;
                })()
            };
        },
        created() {
            this.role = this.$store.getters.roles[0];

        },
        watch: {
            screenWidth(val) {
                this.screenWidth = val;
                // console.log(this.screenWidth);
                if (this.screenWidth < 1000) {
                    $('#langbtn').css('position', 'relative');
                    $('#langbtn').css('left', '50px');
                    $('#langbtn').css('top', '-44px');
                }  else {
                    $('#langbtn').css('position', 'none');
                    $('#langbtn').css('left', '0px');
                    $('#langbtn').css('top', '0px');
                }
            }
        }
    }
</script>

<style type="text/css" scoped>
    .dropdown-itemp {
        text-align: left;
        font-size: 15px;
        padding: 10px;
    }
    @media (min-width: 1000px) {
        #langbtn{
            position: relative;
            left: 0px;
            top: 0px;
        }
    }
    @media (max-width: 1000px) {
        #langbtn{
            position: relative;
            left: 50px;
            top: -44px;
        }
    }
    .header-item .ivu-dropdown-item {
        padding: 15px;
    }

    .header-item {
        width: 130px;
        /*background-color: #20a8d8;*/
        /*background-color: white;*/

        height: 55px;

    }

    [v-cloak] {
        display: none;
    }

    .header-item a {
        color: white !important;

    }

</style>



// WEBPACK FOOTER //
// Header.vue?2cc6a883